import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';

// Pages
import Home from '@/pages/Home';
import Athletes from '@/pages/Athletes';
import Championships from '@/pages/Championships';
import Categories from '@/pages/Categories';
import Shop from '@/pages/Shop';
import Enrollment from '@/pages/Enrollment';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ParentPortal from '@/pages/ParentPortal';
import AdminPanel from '@/pages/AdminPanel';
import ScheduleGrid from '@/pages/ScheduleGrid';

// Components
import WhatsAppButton from '@/components/WhatsAppButton';

// Context
import { AuthProvider, useAuth } from '@/context/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/athletes" element={<Athletes />} />
          <Route path="/championships" element={<Championships />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/enrollment" element={<Enrollment />} />
          <Route path="/schedules" element={<ScheduleGrid />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route 
            path="/parent-portal" 
            element={
              <ProtectedRoute>
                <ParentPortal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireAdmin>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
        </Routes>
        
        {/* WhatsApp Button - Aparece em todas as páginas */}
        <WhatsAppButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;